import React from 'react';
// styles
import styles from './modal-header.module.scss';

interface IProps {
  type?: string;
  children: any;
}

const ModalHeader: React.FC<IProps> = ({ type = '', children }) => {
  return <div className={styles['content' + type]}>{children}</div>;
};

export default ModalHeader;
